// extracted by mini-css-extract-plugin
module.exports = {"menu":"favMenu_menu__72QE7","item":"favMenu_item___yFs1","divider":"favMenu_divider___EOM6"};